export default __webpack_public_path__ + "static/media/robotics.f46c93af.jpg";